export default "__VITE_ASSET__1c0193e7__"